module.exports = __webpack_public_path__ + "static/children-sitting-in-the-grass.086841a8.webp";